// extracted by mini-css-extract-plugin
export default {"SiteOrange":"#EF7C00","SiteLightGrey":"#B1B1B1","Main":"Spinner_Main__9O0jg","MainPadding":"Spinner_MainPadding__z596n","Orange":"Spinner_Orange__c5eOU","Gray":"Spinner_Gray__Ff0CK"};